import React, { FC, ReactNode } from 'react';
import s from './EmptyState.scss';
import {
  Text,
  TextProps,
  TextTypography,
  Spinner,
  SpinnerTypes,
} from 'wix-ui-tpa/cssVars';
import { FormAppEmptyState } from '../../../../../images';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { EmptyStateProps } from '.';

const TextWithChildren = Text as unknown as FC<
  TextProps & { children: ReactNode }
>;

export const EmptyState = ({ loading }: EmptyStateProps) => {
  const { t } = useTranslation();
  const { isEditor } = useEnvironment();

  if (!isEditor) {
    return <div data-hook="Form-wrapper" />;
  }

  return (
    <div className={s.container} data-hook="Form-wrapper">
      {loading ? (
        <Spinner type={SpinnerTypes.slim} />
      ) : (
        <>
          <FormAppEmptyState />
          <TextWithChildren
            className={s.title}
            typography={TextTypography.smallTitle}
          >
            {t('emptyState_title')}
          </TextWithChildren>
          <TextWithChildren className={s.description}>
            {t('emptyState_lineOne')}
          </TextWithChildren>
          <TextWithChildren className={s.description}>
            {t('emptyState_lineTwo')}
          </TextWithChildren>
        </>
      )}
    </div>
  );
};
